// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-39a4b488]{border-radius:.375rem;display:inline-block;margin-left:.25rem;margin-right:.25rem;padding-left:.25rem;padding-right:.25rem;cursor:help}.pop-center[data-v-39a4b488]{max-width:90vw}@media (min-width:768px){.pop-center[data-v-39a4b488]{max-width:42rem}}.pop-center[data-v-39a4b488]{word-wrap:break-word;overflow-wrap:break-word}", ""]);
// Exports
module.exports = exports;
